import { useEffect, useState } from 'react';
import { fetchHealth } from '../api/client';
import { APP_VERSION } from '../lib/appVersion';

interface AboutDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function AboutDialog({ open, onClose }: AboutDialogProps) {
  const [backendVersion, setBackendVersion] = useState<string | null>(null);
  const [gitCommit, setGitCommit] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    void fetchHealth()
      .then((health) => {
        setBackendVersion(health.version);
        setGitCommit(health.git_commit ?? null);
      })
      .catch(() => {
        setBackendVersion(null);
        setGitCommit(null);
      });
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <button
        type="button"
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        aria-label="Close"
        onClick={onClose}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="about-title"
        className="relative w-full max-w-sm rounded-xl border border-border bg-surface-raised p-5 shadow-2xl"
      >
        <h2 id="about-title" className="text-lg font-semibold text-text">
          About Simulation Designer
        </h2>
        <dl className="mt-4 space-y-2 text-sm">
          <div className="flex justify-between gap-4">
            <dt className="text-text-muted">Frontend</dt>
            <dd className="font-mono text-text">v{APP_VERSION}</dd>
          </div>
          <div className="flex justify-between gap-4">
            <dt className="text-text-muted">API</dt>
            <dd className="font-mono text-text">
              {backendVersion ? `v${backendVersion}` : 'Unavailable'}
            </dd>
          </div>
          <div className="flex justify-between gap-4">
            <dt className="text-text-muted">Build commit</dt>
            <dd className="max-w-[12rem] truncate font-mono text-xs text-text">
              {gitCommit ?? 'unknown'}
            </dd>
          </div>
        </dl>
        <button
          type="button"
          className="btn-primary mt-5 w-full"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
}
